import { CustomerModel, CustomerStaffModel } from "../models"

export const toFirstStaffAsAssigneeFromCustomer = (
  customer?: CustomerModel,
): CustomerStaffModel[] => {
  if (customer?.staffs && customer?.staffs.length > 0) {
    const firstStaff = customer.staffs[0]
    const firstAssigneeStaff = {
      ...firstStaff,
      useEmailOnIssuance: true,
    }
    return [firstAssigneeStaff]
  }
  return []
}
